import { styled } from '@mui/material';
import { forwardRef, memo } from 'react';

import TextInput from 'shell/components/TextInput';

const CustomTextInput = styled(TextInput)(({ helperTextPosition }) => {
    const textAlign = {
        start: 'left',
        end: 'right',
    }[helperTextPosition];

    return {
        '& > p.MuiFormHelperText-root': {
            textAlign,
        },
    };
});

export default memo(
    forwardRef(({ helperTextPosition = 'start', placeholder, ...rest }, ref) => {
        return (
            <CustomTextInput
                ref={ref}
                helperTextPosition={helperTextPosition}
                placeholder={placeholder}
                {...rest}
                multiline
            />
        );
    })
);
